import styled from 'styled-components';
import { Heading, propStyling, Text, tombac } from 'tombac';
const StyledRegistration = {
  Heading: styled(Heading).withConfig({
    displayName: "StyledRegistrationUi__Heading"
  })(["font-weight:", ";font-size:", ";text-align:center;"], ({
    level,
    fontWeight
  }) => fontWeight ?? level === 1 ? 700 : 500, ({
    level
  }) => level === 1 ? '32px' : '20px'),
  Page: styled.div.withConfig({
    displayName: "StyledRegistrationUi__Page"
  })(["background:", ";border-top:1px solid ", ";display:flex;justify-content:center;width:100%;@media (max-width:", "){width:auto;}", ";"], tombac.color('neutral', 200), tombac.color('neutral', 300), tombac.unit(1023), propStyling),
  FormBox: styled.div.withConfig({
    displayName: "StyledRegistrationUi__FormBox"
  })(["display:grid;grid-auto-columns:1fr;grid-template-columns:1fr 2fr;column-gap:", ";margin-bottom:", ";@media (max-width:", "){column-gap:", ";}@media (max-width:", "){grid-template-columns:1fr 1fr;}@media (max-width:", "){grid-template-columns:1fr;margin:0 auto;max-width:", ";}"], tombac.space(6), tombac.space(3), tombac.unit(1090), tombac.space(3), tombac.unit(1024), tombac.unit(768), tombac.unit(400)),
  Label: styled(Text).withConfig({
    displayName: "StyledRegistrationUi__Label"
  })(["color:", ";margin-bottom:", ";text-align:center;"], tombac.color('neutral', 600), tombac.space(1)),
  Content: styled.div.withConfig({
    displayName: "StyledRegistrationUi__Content"
  })(["margin:", " auto 0;max-width:100%;padding:", ";width:", ";@media (max-width:", "){padding:", ";}", ";"], tombac.space(4), tombac.space(0, 6), tombac.unit(1200), tombac.unit(1090), tombac.space(0, 3), propStyling),
  ProductsField: styled.div.withConfig({
    displayName: "StyledRegistrationUi__ProductsField"
  })(["@media (max-width:", "){margin-top:", ";}"], tombac.unit(768), tombac.space(3)),
  ProductsBox: styled.div.withConfig({
    displayName: "StyledRegistrationUi__ProductsBox"
  })(["display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:auto;gap:", ";margin-top:", ";@media (max-width:", "){grid-template-columns:1fr;}"], tombac.space(2), tombac.space(0.5), tombac.unit(1024)),
  TermsLabel: styled.label.withConfig({
    displayName: "StyledRegistrationUi__TermsLabel"
  })(["display:flex;"]),
  TermsLabelCopy: styled.div.withConfig({
    displayName: "StyledRegistrationUi__TermsLabelCopy"
  })(["margin-left:", ";", ""], tombac.space(2), tombac.text()),
  TermsBox: styled.div.withConfig({
    displayName: "StyledRegistrationUi__TermsBox"
  })(["display:grid;grid-template-rows:auto;grid-template-columns:1fr auto;align-items:center;border-top:1px solid ", ";position:sticky;bottom:0;background:", ";z-index:1;padding:", ";&::before{content:'';position:absolute;left:0;right:0;top:-", ";height:", ";pointer-events:none;background:radial-gradient( 50% 8px at 50% 100%,rgba(0,0,0,0.16) 0%,rgba(0,0,0,0.1) 25%,rgba(0,0,0,0) 100% );background-repeat:no-repeat;opacity:", ";transition:opacity 150ms ease;}@media (max-width:", "){grid-template-columns:1fr;margin-left:auto;margin-right:auto;margin-top:", ";max-width:", ";padding-bottom:", ";}"], tombac.color('neutral', 400), tombac.color('neutral', 200), tombac.space(3, 0), tombac.unit(8), tombac.unit(8), ({
    $elevated
  }) => $elevated ? 1 : 0, tombac.unit(768), tombac.space(4), tombac.unit(400), tombac.space(2)),
  TermsField: styled.div.withConfig({
    displayName: "StyledRegistrationUi__TermsField"
  })(["display:flex;flex-direction:column;"])
};
export default StyledRegistration;